<template>
    <div v-if="loading">
        <!-- MDL Progress Bar with Indeterminate Progress -->
        <div class="mdl-spinner mdl-js-spinner is-active"></div>
    </div>
    <div v-if="errored">
      An error occurred while loading your magnet. Please scan the QR code again.
    </div>
    <div v-if="!loading & !errored" class="magnet">
      <img id="magnet-motif" v-bind:src="imageSrc" alt="magnet-motif">
      <p id="sight">{{ sight.name }}</p>
      <p id="place">{{ sight.town }}, {{ sight.country }}</p>
      <label for="post_updatable">Add your personal text:</label>
      <textarea v-model="magnet.post" class="mdl-textfield__input" type="text" rows= "5" id="post_updatable"></textarea>
      <button v-on:click="saveMagnet">Save the personal text</button>
      <Maps :coordinateX="sight.coordinateX" :coordinateY="sight.coordinateY" />
    </div>
</template>

<script>
import Maps from './Maps.vue';

export default {
  name: 'NewMagnet',
  components: {
    Maps
  },
  props: {
    magnetID: {
      type: Number,
      default: null
    },
    magnettypeID: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: true,
      errored: false,
      magnet: {
        magnetID: this.magnetID,
        post: "Type your personal text here",
        last_updated: new Date(),
        magnettype: this.magnettypeID
      },
      magnettype: null,
      sight: null,
    }
  },
  mounted: function (){
    this.url = "https://strapi.levt.online/magnettypes/" + this.magnettypeID;

    fetch(this.url)
      .then(response => response.json())
      .then(response => {
          this.magnettype = response
      })
      .catch(error => {
          console.error(error)
          this.errored = true
      })
      .finally(() => {
        this.imageSrc = "https://strapi.levt.online" + this.magnettype.image.url

        fetch("https://strapi.levt.online/sights/"+ this.magnettype.sight.id)
        .then(response => response.json())
        .then(response => {
          this.sight = response
        })
        .catch(error => {
          console.error(error)
          this.errored = true
        })
        .finally(() => {
          this.loading = false
        });
      });
  },
  methods: {
    saveMagnet: function () {
      fetch("https://strapi.levt.online/magnets/", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.magnet),
        })
        .then(response => response.json())
        .then(response => {
          console.log(response)
        })
        .finally(() => {
        })
    }
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#sight {
  font-size: 170%;
  margin: 0%;
}

#magnet-motif {
  width: 90%;
  height: auto;
  margin: 5%;
}

#post_updatable {
  width: 90%;
  margin: 5%;
}
</style>